import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import {
    CreateQuotationTemplateRequestRuntype,
    QuotationTemplateRuntype,
    UpdateQuotationTemplateRequestRuntype,
} from './quotationTemplateBackendTypes';

export const quotationTemplateEndpoints = {
    'GET /quotation-templates': endpoint({
        description: 'List all quotation templates',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            items: z.array(QuotationTemplateRuntype),
        }),
    }),
    'POST /quotation-templates': endpoint({
        description: 'Create a quotation template',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: CreateQuotationTemplateRequestRuntype,
        invalidates: ['GET /quotation-templates'],
        responseBody: QuotationTemplateRuntype,
    }),
    'GET /quotation-templates/:id': endpoint({
        description: 'Get a single quotation template',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: QuotationTemplateRuntype,
    }),
    'PATCH /quotation-templates/:id': endpoint({
        description: 'Update a quotation template',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: UpdateQuotationTemplateRequestRuntype,
        invalidates: ['GET /quotation-templates', 'GET /quotation-templates/:id'],
        responseBody: QuotationTemplateRuntype,
    }),
    'DELETE /quotation-templates/:id': endpoint({
        description: 'Delete a quotation template',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        invalidates: ['GET /quotation-templates'],
        responseBody: z.object({ deleted: z.number() }),
    }),
    'POST /quotation-templates/:id/duplicate': endpoint({
        description: 'Duplicate a quotation template',
        pathParams: z.object({ id: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.object({ name: z.string().min(1) }),
        invalidates: ['GET /quotation-templates'],
        responseBody: QuotationTemplateRuntype,
    }),
};
